module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_ehime-ee66fb5aa2df42192a5ccf74addf08e7.png";